module.exports = __webpack_public_path__ + "img/b18.057fec71.jpg";